.featuredContainer {
  padding-top: 16px;
  padding-bottom: 24px;
}

.goldTabContainer {
  padding-top: 24px;
}

.janeGoldTitle {
  padding-left: 8px;
}

@media all and (--reefer-media-tablet-min) {
  .featuredContainer {
    padding-bottom: 32px;
  }

  .goldTabContainer {
    padding-top: 40px;
  }
}
